module.exports = __webpack_public_path__ + "static/media/messaging-application.b6f5404a.svg";